const Applications = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Applications</h1>
      <p className="text-gray-600">Manage your campaign applications here...</p>
    </div>
  );
};

export default Applications;
